import React from "react";

// Hooks
import { useFetchUser } from "../../../hooks/useFetchUser";

// Components
import Loading from "../../general/Loading";
import SubDomainSignin from "../../pages/portal/SubDomainSignIn";

const BaseLayout: React.FC = ({ children }) => {
    const { loading } = useFetchUser();

    return (
        <>
            <SubDomainSignin />
            <Loading loading={loading} />
            <div className="baseLayout__container">
                <main>
                    <div className="baseLayout__toolbar" />
                    {children}
                </main>
            </div>
        </>
    );
};

export default BaseLayout;
